import React from 'react';
import Navbar from '../../components/Home/Navbar';
import Sidebar from '../../components/Home/SideBar';
import BottomNav from '../../components/Home/BottomNav';

function Layout({child ,  children }) {
  return (
    <div>
      <Navbar child={child} />
      <div className='bottom'>
        <BottomNav/>
        <Sidebar />
        <div className='main-container'>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;
